import TitledItem from "./TitledItem";

export default function TitledContents(props){
  const product = props.product;  
  const titledContents = product.titledContents;
  const rows = Math.ceil(titledContents.length/2);
  const leftSide = titledContents.slice(0, rows);
  const rightSide = titledContents.slice(rows)
  return (
    <div className="flex flex-col my-10 lg:flex-row lg:justify-stretch">
      {/* left side */}
      <div className="lg:mr-8 lg:w-[350px]">
        {leftSide.map((item, index)=> <TitledItem key={index} title={item.title} comments={item.comments}/>)}
      </div>
      {/* right side */}
      <div className="lg:ml-8 lg:w-[350px]">
        {rightSide.map((item, index)=> <TitledItem key={index+rows} title={item.title} comments={item.comments}/>)}
      </div>
    </div>
  );
}